import { z } from 'zod'

import { EnumBuilder, type ZodSimplify } from '@mntn-dev/utility-types'
import { BidIdSchema } from '../unique-id.models.ts'
import { SurveyFeedbackSchema } from './common.ts'
import { SurveyTypeSchema } from './survey-types.ts'

export const [
  BidRejectedReasons,
  BidRejectedReasonSchema,
  BidRejectedReasonEnum,
] = EnumBuilder(
  'lack-of-relevant-examples',
  'lack-of-expertise-in-required-skillset',
  'budget-too-high',
  'poor-past-experience-with-maker',
  'not-enough-information-in-pitch',
  'language-proficiency-or-location-not-ideal',
  'other'
)

export type BidRejectedReason = ZodSimplify<typeof BidRejectedReasonSchema>

export const BidRejectedResponsesSchema = z.discriminatedUnion('reason', [
  z.object({
    reason: BidRejectedReasonSchema.extract(['other']),
    feedback: SurveyFeedbackSchema,
  }),
  z.object({
    reason: BidRejectedReasonSchema.exclude(['other']),
    feedback: SurveyFeedbackSchema.optional(),
  }),
])

export type BidRejectedResponses = ZodSimplify<
  typeof BidRejectedResponsesSchema
>

export const BidRejectedSurveyDetailsSchema = z.object({
  surveyType: SurveyTypeSchema.extract(['bid-rejected-by-brand']),
  bidId: BidIdSchema,
  responses: BidRejectedResponsesSchema,
})
